const BACK_URI_KEY = 'backUri';
import Oidc from 'oidc-client';
import { buildOidcConfig } from './oidcConfig';

class BaseAuthService {
    constructor($window, $location, platformService, envService) {
        this.$window = $window;
        this.$location = $location;
        this.platformService = platformService;
        this.envService = envService;
    }

    setBackUri() {
        let route = this.$location.url();
        if (route && route !== '/meetings') {
            this.$window.localStorage.setItem(BACK_URI_KEY, route);
        }
    }

    removeBackUri() {
        this.$window.localStorage.removeItem(BACK_URI_KEY);
    }

    getBackUri() {
        this.$window.localStorage.getItem(BACK_URI_KEY);
    }

    getClientConfig() {
        let stratsysAuthorityUrl = this.platformService.getStratsysAuthorityUrl();
        if (stratsysAuthorityUrl) {
            return this._getPlatformIdpConfig(stratsysAuthorityUrl);
        }

        return null;
    }

    _getPlatformIdpConfig(authorityUrl) {
        return buildOidcConfig({
            authorityUrl: authorityUrl,
            clientId: this.envService.STRATSYS_CLIENT_ID
        });
    }
}

BaseAuthService.$inject = ['$window', '$location', 'platformService', 'envService'];

export default BaseAuthService;
